import i18n from '../../i18n';
import { validateSetupLinkedInUrl } from './setupLinkedInUrl';

const MIN_COMPANY_NAME_LENGTH = 2;
const MAX_COMPANY_NAME_LENGTH = 120;
const MAX_AGENT_NAME_LENGTH = 80;

export const validateAgentConfiguration = ({ agentName, companyName, linkedinUrl }) => {
  const errors = {};
  const trimmedAgentName = agentName?.trim?.() || '';
  const trimmedCompanyName = companyName?.trim?.() || '';

  if (!trimmedAgentName) {
    errors.agentName = i18n.t('ai.validation.agentNameRequired');
  } else if (trimmedAgentName.length > MAX_AGENT_NAME_LENGTH) {
    errors.agentName = i18n.t('ai.validation.agentNameMax', { max: MAX_AGENT_NAME_LENGTH });
  }

  if (!trimmedCompanyName) {
    errors.companyName = i18n.t('ai.validation.companyNameRequired');
  } else if (trimmedCompanyName.length < MIN_COMPANY_NAME_LENGTH) {
    errors.companyName = i18n.t('ai.validation.companyNameMin', { min: MIN_COMPANY_NAME_LENGTH });
  } else if (trimmedCompanyName.length > MAX_COMPANY_NAME_LENGTH) {
    errors.companyName = i18n.t('ai.validation.companyNameMax', { max: MAX_COMPANY_NAME_LENGTH });
  }

  const linkedInValidation = validateSetupLinkedInUrl(linkedinUrl);
  if (linkedInValidation.error) {
    errors.linkedinUrl = linkedInValidation.error;
  }

  return {
    errors,
    isValid: Object.keys(errors).length === 0,
    values: {
      agentName: trimmedAgentName,
      companyName: trimmedCompanyName,
      linkedinUrl: linkedInValidation.value,
    },
  };
};
